var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from "react";
import useColor from "../../../hooks/use-color";
var border = function (_a) {
    var borderSideColor = _a.borderSideColor, borderTopColor = _a.borderTopColor, showBorderLeft = _a.showBorderLeft;
    return (__assign({ borderRight: "1px solid ".concat(borderSideColor), borderTop: "3px solid ".concat(borderTopColor) }, (showBorderLeft ? { borderLeft: "1px solid ".concat(borderSideColor) } : {})));
};
var useStyleTabs = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.showBorderLeft, showBorderLeft = _c === void 0 ? false : _c;
    var pickColor = useColor();
    var borderSideColor = pickColor("borderSecondary");
    var borderTopColor = active ? pickColor("primary") : "transparent";
    var rootStyles = useMemo(function () {
        return {
            cursor: "pointer",
            gap: 1,
            alignItems: "center",
            justifyContent: "start",
            position: "relative",
            padding: [2, 3],
            background: active ? "mainBackground" : "elementBackground",
            zIndex: active ? 2 : 1,
            height: 8,
            sx: __assign({}, border({ borderSideColor: borderSideColor, borderTopColor: borderTopColor, showBorderLeft: showBorderLeft })),
        };
    }, [borderTopColor, borderSideColor, active]);
    return { rootStyles: rootStyles };
};
export default useStyleTabs;
